import Draggable from './component'

export default Draggable